<div class="container-full" style="margin-top:10px;">
    <app-header-title-lot-data
    [title]="'Tenant Roster'"
    [lotNumber]="_appGeneralState.currentLotNumber"
    [lotName]="_appGeneralState.currentLotName"
></app-header-title-lot-data>
    
    <mat-card style="margin-top:30px;margin-left:10px;margin-right:0px;width:99%;height:90%;min-height: 600px;">
        <mat-card-header>
        
        </mat-card-header>    
        <mat-card-content>
                <form 
                (ngSubmit)="onFetchTenantRoster()" 
                novalidate
                [formGroup]="tenantSearchForm" 
                style="margin-top:20px;">
            <div class="row" style="width:100%;">
                <!-- <div class="col-4">
                   
                    Current Lot: {{_appGeneralState.currentLotNumber}}-{{_appGeneralState.currentLotName}}
                </div> -->
                <div class="col-6">
                    <mat-form-field appearance="fill" style="width:100%;color:gray">
                        <mat-label>Company:</mat-label>
                        <mat-select formControlName="companyId">
                          <mat-option value="NULL">All Companies</mat-option>
                          <mat-option *ngFor="let company of companyList" [value]="company.companyId" >
                           {{company.companyName}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                </div>
                <div class="col-6">
                        <mat-form-field style="width:100%;color:gray">
                            <mat-label>Choose the "As Of" date</mat-label>
                            <input matInput [matDatepicker]="picker" formControlName="asOfDate" DateToCurrentYearStandalone>
                            <mat-hint>MM/DD/YYYY</mat-hint>
                            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                          </mat-form-field>
                </div>
            </div>
            <div class="row" style="width:100%;margin-top:2px;">
                <div class="col-12">
                    <button type="submit" class="btn btn-primary mt-3 ace-blue" style="margin-left:20px;" [disabled]="!tenantSearchForm.valid">Search</button>
                    <button type="button" class="btn btn-primary mt-3 ace-blue" style="margin-left:20px;" (click)="onClearTenantSearchForm()">Clear</button>
                </div>    
            </div>
        </form>

        <ng-container *ngIf="queryInProcess">
            <div class="row mt-3" >
                <div class="col-12 text-center">
                    <span><strong>Stand by while we load the data for the Tenant Report...</strong></span>
                </div>
            </div>
            <div style="margin-top:30px;">
                <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                
            </div>
        </ng-container>

        <ng-container *ngIf="!queryCompleted && queryInProcess == false">
            <div style="margin-top:30px;margin-left:20px;">
                <strong>Click Search to find data for the Tenant Report</strong>
            </div>
        </ng-container>

        <ng-container *ngIf="queryCompleted && tenantData.length == 0">
            <div style="margin-top:30px;margin-left:20px;">
                <strong>No data found matching this search criteria</strong>
            </div>
        </ng-container>

        <ng-container *ngIf="this.tenantData.length > 0">
        <mat-tab-group>
            <mat-tab label="Roster">
               
                    <div style="margin-top:30px;"></div>
                    <div class="ace-heading-text-secondary" style="font-size:21px;margin-left:10px;">
                      Total Profiles: {{tenantData.length}}
                      <!-- <button mat-fab aria-label="Export" matTooltip="Export Tenant Roster" style="margin-left:20px;" (click)="onDownloadRawRosterReport()">
                        <mat-icon>file_download</mat-icon>
                      </button> -->
                    </div>
                    <igx-grid #gridTenant id="gridTenant" [data]="tenantDisplayData" [width]="'99%'" [height]="'2000px;'" [autoGenerate]="false" style=margin-left:10px;margin-top:10px;
                        paste-handler  [primaryKey]="'parkerId'" [rowEditable]="false" [allowFiltering]="true"  filterMode="excelStyleFilter" displayDensity="compact" 
                        [emptyGridMessage]="'Report Tenant Data List No Data Found'"  paste-handler   >
                    
                        <igx-column field="lotNumber" header="Lot No." width="125px" required [sortable]="true" ></igx-column>
                        <igx-column field="companyName" header="Company" width="275px" required [sortable]="true" ></igx-column>
                        <igx-column field="parkerName" header="Parker" width="250px" required [sortable]="true" ></igx-column>
                        <igx-column field="stallType" header="Stall Type" width="175px" required [sortable]="true" ></igx-column>
                        <igx-column field="vehicleLicense" header="License" required width="150px"></igx-column>
                        <igx-column field="cardNumber" header="Card #" required width="125px"></igx-column>
                        <igx-column field="stallNumber" header="Stall #" required width="125px"></igx-column>
                        <igx-column field="parkerPayType" header="Parker Pay Type" required width="175px"></igx-column>
                        <igx-column field="companyPaid" header="Company Paid" required width="125px">
                            <ng-template igxCell let-value let-cell="cell">
                                <div class="cell__inner">
                                      {{value | currency}}             
                                </div>
                            </ng-template>
                        </igx-column>
                        <igx-column field="parkerPaid" header="Parker Paid" required width="125px">
                            <ng-template igxCell let-value let-cell="cell">
                                <div class="cell__inner">
                                      {{value | currency}}             
                                </div>
                            </ng-template>
                        </igx-column>
                        <igx-column field="total" header="Total" required width="125px">
                            <ng-template igxCell let-value let-cell="cell">
                                <div class="cell__inner">
                                      {{value | currency}}             
                                </div>
                            </ng-template>
                        </igx-column>
                        
                        <igx-grid-toolbar>
                            <igx-grid-toolbar-actions>
                                <igx-grid-toolbar-pinning></igx-grid-toolbar-pinning>
                                <igx-grid-toolbar-hiding></igx-grid-toolbar-hiding>
                                <igx-grid-toolbar-exporter></igx-grid-toolbar-exporter>
                            </igx-grid-toolbar-actions>
                        </igx-grid-toolbar>
                        
                        </igx-grid>
                              
            </mat-tab>
            
            <mat-tab label="Grouped by Company"> 
                
                    <div style="margin-top:30px;"></div>
                    <div class="row" style="width:100%">
                        <div class="col-6">
                            <div class="ace-heading-text-secondary" style="font-size:21px;margin-left:10px;">
                                Total Profiles: {{tenantData.length}}  
                            </div>     
                        </div>
                        <div class="col-6 text-end">
                            <!-- <button mat-fab aria-label="Export"  style="margin-left:20px;" >
                                <mat-icon>file_download</mat-icon>
                            </button> -->
                            <button mat-stroked-button style="color:red;border-color: red" 
                                (click)="onDownloadTenantReportPreparedFile()" matTooltip="Export Tenant Roster">EXPORT</button>
                        </div>
                    </div>

                    <igx-grid #gridExport id="tenantExportData" [data]="tenantExportData" [width]="'99%'" [height]="'2000px;'" [autoGenerate]="false" style=margin-left:10px;margin-top:10px;
                        paste-handler  [primaryKey]="'parkerId'" [rowEditable]="false" [allowFiltering]="true"  filterMode="excelStyleFilter" displayDensity="compact" 
                        [emptyGridMessage]="'Report Tenant Data List No Data Found'"  paste-handler   >
                        
                        <igx-column field="companyName" header="Company" width="225px" required ></igx-column>
                        <igx-column field="parkerName" header="Parker" width="200px" required ></igx-column>
                        <igx-column field="stallType" header="Stall Type" width="175px" required></igx-column>
                        <igx-column field="vehicleLicense" header="License" required width="150px"></igx-column>
                        <igx-column field="cardNumber" header="Card #" required width="100px"></igx-column>
                        <igx-column field="stallNumber" header="Stall #" required width="125px"></igx-column>
                        <igx-column field="parkerPayType" header="Parker Pay Type" required width="225px"></igx-column>
                        <igx-column field="companyPaid" header="Company Paid" required width="150px">
                            <ng-template igxCell let-value let-cell="cell">
                                <div class="cell__inner">
                                      {{value | currency}}             
                                </div>
                            </ng-template>
                        </igx-column>
                        <igx-column field="parkerPaid" header="Parker Paid" required width="125px">
                            <ng-template igxCell let-value let-cell="cell">
                                <div class="cell__inner">
                                      {{value | currency}}             
                                </div>
                            </ng-template>
                        </igx-column>
                        <igx-column field="total" header="Total" required width="125px">
                            <ng-template igxCell let-value let-cell="cell">
                                <div class="cell__inner">
                                      {{value | currency}}             
                                </div>
                            </ng-template>
                        </igx-column>
                        
                        
                        <igx-grid-toolbar>
                            <igx-grid-toolbar-actions>
                                <!-- <igx-grid-toolbar-pinning></igx-grid-toolbar-pinning>
                                <igx-grid-toolbar-hiding></igx-grid-toolbar-hiding>
                                <igx-grid-toolbar-exporter></igx-grid-toolbar-exporter> -->
                            </igx-grid-toolbar-actions>
                        </igx-grid-toolbar>
                        
                        </igx-grid>
                              
            </mat-tab>
           

          </mat-tab-group>

        </ng-container>

        </mat-card-content>
        <mat-card-actions style="margin-top:20px;">
            
      </mat-card-actions>
  
    </mat-card>                                                                             

</div>



